<template>
    <div>
        <div class="layer-ios" v-if="iosShow">
            <div class="layer-ios-tips">
                <div>
                    1. 点击右上角的<span class="iconfont icon-gengduo"></span>按钮
                    <span class="iconfont icon-iconset0445"></span>
                </div>
                <div class="tips1">
                    2. 在safari浏览器中打开
                    <img class="tips-icon" src="../../assets/safari.png"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../../store'
export default {
  name: 'authlogin',
  store: store,
  data () {
    return {
      iosShow: false
    }
  },
  mounted () {
    document.body.parentNode.style.overflow = "hidden"
    let that = this
    let msg = this.$route.params
    store().dispatch('loginIn', msg)
    if (this.isIOS() && !this.isSafari() && parseInt(msg.val) === 1) {
      this.iosShow = true
      // setTimeout(() => {
      //   store().dispatch('loginOut')
      // }, 5000)
    } else {
      console.log(localStorage.getItem('url'))
      if (localStorage.getItem('url')) {
        that.$router.push(localStorage.getItem('url'))
      } else {
        that.$router.push('/?id=' + msg.id)
      }
      // that.$router.push('/?id=' + msg.id)
    }
    // if (!localStorage.getItem('url')) {
    //   that.$router.push('/?id=' + msg.id)
    // } else {
    //   that.$router.push(localStorage.getItem('url'))
    // }
    // localStorage.removeItem('url')
  },
  methods: {
    // 是否ios
    isIOS () {
      let u = navigator.userAgent
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
    // 是否Safari
    isSafari () {
      let agent = navigator.userAgent.toLowerCase()
      return agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0
    }
  }
}
</script>

<style lang="scss" scoped>
    .layer-ios{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #eeeeee;
        .layer-ios-tips{
            font-size: 18px;
            color: #666666;
            text-align: center;
            margin-top: 12%;
        }
        .tips-icon{
            width: 58px;
            height: 58px;
            position: relative;
            top: 18px;
        }
        .icon-iconset0445{
            margin-left: 12px;
            font-size: 53px;
            position: relative;
            top: -16px;
            left: 10px;
        }
        .icon-gengduo{
            margin: 0 2px;
        }
        .tips1{
            /*margin-top: 10px;*/
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/users/authlogin.vue